import { render } from "./AppraiseDetail.vue?vue&type=template&id=e2887260&scoped=true"
import script from "./AppraiseDetail.vue?vue&type=script&lang=js"
export * from "./AppraiseDetail.vue?vue&type=script&lang=js"

import "./AppraiseDetail.vue?vue&type=style&index=0&id=e2887260&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2887260"]])

export default __exports__